// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fake-player {
  position: relative;
  width: auto;
  padding-bottom: 50%;
  background-color: #333;
  height: calc(100vh - 6rem);
}
.fake-player__content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 2rem;
  text-align: center;
  line-height: 3.2rem;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/FakePlayer/FakePlayer.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EAEA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;AAAJ;AAEI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAAR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
